<template>
  <div class="d-flex justify-center try-product">
    <div class="block-width d-flex justify-between align-center">
      <div class="w-40">
        <h1 class="mt-0">{{ $t('try_our_product') }}</h1>
        <p class="text-md fw-400 mb-2">{{$t('try_our_product_text')}}</p>
        <div class="d-flex align-center mb-15">
          <img src="@/assets/images/icons/circle-1.svg" class="mr-05" alt="icon" width="24" height="24" style="aspect-ratio: auto 24 / 24;"/>
          <img src="@/assets/images/icons/arrow-right.svg" class="mr-05" alt="icon" width="20" height="20" style="aspect-ratio: auto 20 / 20;"/>
          <p class="text-md fw-400">{{$t('try_product_1')}}</p>
        </div>
        <div class="d-flex align-center mb-15">
          <img src="@/assets/images/icons/circle-2.svg" class="mr-05" alt="icon" width="24" height="24" style="aspect-ratio: auto 24 / 24;"/>
          <img src="@/assets/images/icons/arrow-right.svg" class="mr-05" alt="icon" width="20" height="20" style="aspect-ratio: auto 20 / 20;"/>
          <p class="text-md fw-400">{{$t('try_product_2')}}</p>
        </div>
        <div class="d-flex align-center">
          <img src="@/assets/images/icons/circle-3.svg" class="mr-05" alt="icon" width="24" height="24" style="aspect-ratio: auto 24 / 24;"/>
          <img src="@/assets/images/icons/arrow-right.svg" class="mr-05" alt="icon" width="20" height="20" style="aspect-ratio: auto 20 / 20;"/>
          <p class="text-md fw-400">{{$t('try_product_3')}}</p>
        </div>
      </div>
      <div class="w-58">
        <input
          :placeholder="$t('name')"
          :class="isError?'custom-input w-100 mb-1 custom-input__error':'custom-input w-100 mb-1'"
          v-model="form.name"
        />
        <div class="d-flex justify-between w-100 mb-1">
          <input
            placeholder="Email"
            class="w-49 custom-input"
            v-model="form.email"
          />
          <input
            :class="isError?'custom-input custom-input__error w-49':'custom-input w-49'"
            v-model="form.phone"
            v-maska="'+7(###)###-##-##'"
            placeholder="+7(700)000-00-00"/>
        </div>
        <textarea
          v-model="form.message"
          :class="isError?'custom-input custom-input__error w-100 mb-1':'custom-input w-100 mb-1'"
          :placeholder="$t('textarea_placeholder')"
          style="max-width: 100%; height: 100px; max-height: 100px; min-width: 100%"
        />
        <TheButtonPrimary
          :disabled="isLoading"
          :content="$t('contact_us')"
          :class="isLoading?'w-100 button-primary__large button-primary__loading':'w-100 button-primary__large'"
          @click="sendMail"
        >
          <template #icon>
            <img src="../../assets/images/icons/plus-circle-white.svg" class="ml-1" alt="icon" width="29" height="28" style="aspect-ratio: auto 29 / 28;"/>
          </template>
        </TheButtonPrimary>
      </div>
    </div>
  </div>
</template>
<script setup>
import TheButtonPrimary from "@/components/TheButton/TheButtonPrimary.vue";
import {onMounted, ref} from 'vue'
import emailjs from '@emailjs/browser';
import {vMaska} from "maska/vue";
import {useRoute, useRouter} from "vue-router";
import {useI18n} from "vue-i18n";

const route = useRoute()
const {t} = useI18n()

const form = ref({
  email: '',
  name: '',
  phone: '',
  message: route.params.message?t(route.params.message):''
})

const isLoading = ref(false)
const status = ref('none')
const router = useRouter()
const isError = ref(false)

const sendMail = () =>{
  isLoading.value = true
  if(form.value.name!=='' && ((form.value.phone!=='' && form.value.phone.length===16) || form.value.email) && form.value.message!==''){
    emailjs.init({
      publicKey: 'Q_YW--2Al-j27RRE1',
      // Do not allow headless browsers
      blockHeadless: true,
      blockList: {
        // Block the suspended emails
        list: ['foo@emailjs.com', 'bar@emailjs.com'],
        // The variable contains the email address
        watchVariable: 'userEmail',
      },
      limitRate: {
        // Set the limit rate for the application
        id: 'app',
        // Allow 1 request per 10s
        throttle: 10000,
      },
    });
    emailjs.send('service_xwjrr45', 'template_u8jlojv', form.value).then(
        () => {
          isLoading.value = false
          router.push('/email-sent')
        },
        () => {
          alert('Что-то пошло не так');
          isLoading.value = false
          status.value = 'error'
        })
  }
  else {
    isLoading.value = false
    isError.value = true
  }
}

onMounted(
    () => window.scrollTo(0, 0)
)
</script>